<template>
  <div class="checkbox styled" @click="onClick">
    <input type="checkbox" :name="name" :checked="allChecked" />
    <label></label>
  </div>
</template>

<script>
/**
 * The SelectAllMarker component.
 */

export default {
  props: {
    name: {
      type: String,
      default: 'selectAll'
    },
    allChecked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('selected');
    }
  }
};
</script>

<style scoped>
.checkbox {
  top: 5px;
}
</style>
